import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { User } from 'src/app/models/users.model';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { first } from 'rxjs/operators';
import { fadeOut } from 'src/app/shared/animations';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss'],
  animations: [fadeOut],
})
export class SplashComponent implements OnInit {
  showSplash = true;
  user: User;

  constructor(private afAuth: AngularFireAuth) {}

  async ngOnInit() {
    await this.afAuth.user.pipe(first()).toPromise();

    setTimeout(() => {
      this.showSplash = false;
    }, 1500);
  }
}
